import {visibleIfArray} from "./visibleIf";
import dotProp from 'dot-prop-immutable';
import PubSub from "pubsub-js";
import * as pubSubMessages from "../store/pubSubMessages";
import * as actionTypes from "../../../store/actions/actionTypes";
import {validateMedicare} from "./medicare";

export const customValidationForm = (formStructure, values, valid, dispatch) => {
    let result = valid;
    let shouldScroll = valid;
    const setError = (name, errorText = '') => {
        result = false;
        PubSub.publish(pubSubMessages.VALIDATION_ERROR_SET, name);
        if (shouldScroll) {
            PubSub.publish(pubSubMessages.VALIDATION_ERROR_SCROLL, name);
        }
        if (errorText) {
            // new way to handle errors. Probably, pubSub could be deprecated sometime
            dispatch({type: actionTypes.CUSTOM_VALIDATION_SET_ERROR, variable: name, error: errorText});
        }
        shouldScroll = false;
    }

    const clearError = (name) => {
        PubSub.publish(pubSubMessages.VALIDATION_ERROR_CLEAR, name);
        dispatch({type: actionTypes.CUSTOM_VALIDATION_SET_ERROR, variable: name, error: false});
    }

    formStructure.cards.map((card) => {
        if (!card.visibleIf || visibleIfArray(card.visibleIf,  values)) {
            card.rows.map((row) => {
                if (!row.visibleIf || visibleIfArray(row.visibleIf, values)) {
                    row.items.forEach((item) => {
// Custom List validation
                        if ((item.type === 'CustomList') && item.required) {
                            const validationResult = customListValidationWithDetails(item, values);
                            console.log('[CustomList validation]', item.namePrefix, 'errors:', validationResult.fieldErrors, 'shouldScroll:', shouldScroll);

                            if (validationResult.fieldErrors.length > 0) {
                                result = false;
                                // Scroll to first field with error
                                if (shouldScroll) {
                                    setTimeout(() => {
                                        const element = document.getElementById(validationResult.fieldErrors[0]);
                                        if (!element) return;
                                        const elementRect = element.getBoundingClientRect();
                                        const absoluteElementTop = elementRect.top + window.pageYOffset;
                                        const middle = absoluteElementTop - (window.innerHeight / 2);
                                        window.scrollTo(0, middle);
                                    }, 50);
                                    shouldScroll = false;
                                }
                            }

                            // Set/clear per-field errors
                            const count = dotProp.get(values.values, `${item.namePrefix}_count`) || 0;
                            for (let i = 0; i < count; i++) {
                                item.columns.forEach(column => {
                                    const fieldName = `${item.namePrefix}${column.namePrefix}${i}`;
                                    const hasError = validationResult.fieldErrors.includes(fieldName);
                                    dispatch({
                                        type: actionTypes.CUSTOM_VALIDATION_SET_ERROR,
                                        variable: fieldName,
                                        error: hasError ? 'Required' : false
                                    });
                                });
                            }
                        }

                        // Checkboxes "requiredAllOptions" - every option must be ticked
                        if ((item.type === 'Checkboxes') && item.requiredAllOptions) {
                            if (checkboxesAllOptionsSelected(item, values)) {
                                clearError(item.name);
                            } else {
                                setError(item.name);
                            }
                        }

                        if(!item.customValidation || !dotProp.get(values.values, item.name)) {
                            // ACA-21 - we do not validate empty values - required prop used for that
                            return false;
                        }

                        const _err = customValidationItemErrors(item.customValidation, dotProp.get(values.values, item.name));
                        // console.log('[custom]', item, _err);
                        if (!_err.length) {
                            clearError(item.name)
                        } else {
                            // console.log('[customValidation]', item.customValidation, 'Invalid');
                            setError(item.name, _err[0]);
                        }
                    });
                }
            });
        }
    });
    return result;
}

const customValidationItemErrors = (validationTypes, itemValue) => {
    if (!Array.isArray(validationTypes)) {
        validationTypes = [validationTypes];
    }
    let results = [];
    validationTypes.forEach(i => {
        // console.log('[custom]', itemValue, i);
        switch (i) {
            case "10-digits":
                if (itemValue && !/^\d{10}$/.test(itemValue)) {
                    results.push('Value should be 10 digits number');
                }
                break;
            case "2-digits":
                if (itemValue && !/^\d{2}$/.test(itemValue)) {
                    results.push('Value should be 2 digits number');
                }
                break;
            case "medicare":
                if (itemValue && !validateMedicare(itemValue)) {
                    results.push('Invalid Medicare number');
                }
                break;
        }
    })

    return results;
}

/**
 * Checkboxes "requiredAllOptions" validation.
 *
 * Unlike the standard `required` (which is satisfied by a single ticked box),
 * this returns true only when EVERY option of the checkbox group is selected.
 */
export const checkboxesAllOptionsSelected = (item, values) => {
    const value = dotProp.get(values.values, item.name);
    if (!value || (typeof value !== 'object')) {
        return false;
    }
    return (item.options || []).every((option) => {
        // options may be raw strings (template) or {value,label} (after render)
        const optionValue = (typeof option === 'string') ? option : option.value;
        return !!value[optionValue];
    });
};

export const customListValidation = (item, values) => {
    // console.log('[CustomList]', `${item.namePrefix}_count`, dotProp.get(values.values, `${item.namePrefix}_count`));
    let haveCompleteRow = false;
    for (let i = 0;i<dotProp.get(values.values, `${item.namePrefix}_count`);i++) {
        let completeRow = true;
        let emptyRow = true;
        item.columns.map(column => {
            if (
                !dotProp.get(values.values, `${item.namePrefix}${column.namePrefix}${i}`)
            ) {
                if (column.required !== false) {
                    // console.log('[CustomList] Empty ',column.namePrefix, i );
                    completeRow = false;
                }
            } else {
                emptyRow = false;
            }
        });
        if (completeRow) {
            haveCompleteRow = true;
        }
        if (!emptyRow && !completeRow) {
            return false;
        }
        // console.log('[CustomList] ', haveCompleteRow)
    }
    return haveCompleteRow;
}

export const customListValidationWithDetails = (item, values) => {
    let haveCompleteRow = false;
    const fieldErrors = [];

    for (let i = 0; i < dotProp.get(values.values, `${item.namePrefix}_count`); i++) {
        let completeRow = true;
        let emptyRow = true;

        item.columns.forEach(column => {
            const fieldName = `${item.namePrefix}${column.namePrefix}${i}`;
            const fieldValue = dotProp.get(values.values, fieldName);

            if (!fieldValue) {
                if (column.required !== false) {
                    completeRow = false;
                }
            } else {
                emptyRow = false;
            }
        });

        // Mark errors only on partial rows (some filled, some empty)
        if (!emptyRow && !completeRow) {
            item.columns.forEach(column => {
                const fieldName = `${item.namePrefix}${column.namePrefix}${i}`;
                const fieldValue = dotProp.get(values.values, fieldName);
                if (!fieldValue && column.required !== false) {
                    fieldErrors.push(fieldName);
                }
            });
        }

        if (completeRow) haveCompleteRow = true;
    }

    // If no complete row and list required - mark first row required fields
    if (!haveCompleteRow && item.required) {
        item.columns.forEach(column => {
            const fieldName = `${item.namePrefix}${column.namePrefix}0`;
            const fieldValue = dotProp.get(values.values, fieldName);
            if (!fieldValue && column.required !== false && !fieldErrors.includes(fieldName)) {
                fieldErrors.push(fieldName);
            }
        });
    }

    return { valid: haveCompleteRow && fieldErrors.length === 0, fieldErrors };
}